export default __webpack_public_path__ + "static/media/orsetto.a62b6873.png";